import { toasts as EnUsToasts } from '../en-us/toasts';
import { AgResourceLanguage } from '../types';

export const toasts: AgResourceLanguage['toasts'] = {
  ...EnUsToasts,
  useChangeShippingMethod: {
    ...EnUsToasts.useChangeShippingMethod,
    nextOrderMethodChanged: 'Verzendmethode voor volgende bestelling succesvol gewijzigd',
    subscriptionMethodChanged: 'Verzendmethode voor abonnement succesvol gewijzigd'
  },
  commonError: 'Er ging iets mis. Probeer het opnieuw',
  shippingBillingAddress: {
    ...EnUsToasts.shippingBillingAddress,
    errorZipCode: 'Voer een geldige postcode in',
    errorHtmlTag: 'mag niet bevatten',
    successNextOrder: 'Verzendadres voor volgende bestelling succesvol gewijzigd',
    successSubscription: 'Verzendadres voor abonnement succesvol gewijzigd',
    successCheckout: 'Verzendadres succesvol gewijzigd'
  },
  changePaymentMethod: {
    ...EnUsToasts.changePaymentMethod,
    cantRemovePaymentMethod: 'Kan betaalmethode niet verwijderen: onjuiste klant-ID',
    removedPaymentMethod: 'Betaalmethode succesvol verwijderd en gewijzigd',
    changedPaymentMethod: 'Betaalmethode succesvol gewijzigd',
    incorrectId: 'Onjuist order-ID'
  },
  orderCreated: 'Bestelling is aangemaakt',
  migrationToV53: {
    title: 'Uw AG1 is geüpgraded!',
    description: 'U heeft nu een abonnement op de geüpgradede versie van AG1.'
  }
};
